import { graphql } from '@/generated/gql';

export const USER_AVAILABILITY_LIST_QUERY = graphql(/* GraphQL */ `
  query UserAvailabilityList(
    $dateRange: AstroDateRangeInput
    $filter: AstroQueryBuilderQuery
    $order: [AstroUserAvailabilityOrder!]
  ) {
    astronaut {
      userAvailability(dateRange: $dateRange, filter: $filter, order: $order) {
        totalCount
        columns {
          weekStart
          weekEnd
        }
        nodes {
          id
          user {
            id
            firstName
            lastName
            email
            pictureId
            workingHours
          }
          availabilityPerWeek {
            weekStart
            availability
          }
        }
      }
    }
  }
`);
